import { AdPlacement, Article as ArticleType } from '@api/api';
import { Article } from '@components/article/Article/Article';
import { ArticleProps } from '@components/article/Article/Article.types';
import { buildArticleLink } from '@utils/link';
import { FC } from 'react';

export interface NextArticlesProps {
  articles: ArticleType[];
  canLoadMore: boolean;
  onReachArticleEnd: ArticleProps['onEndReach'];
  onArticleVisible: ArticleProps['onArticleVisible'];
  ads: AdPlacement[];
}

export const NextArticles: FC<NextArticlesProps> = ({
  articles,
  canLoadMore,
  onArticleVisible,
  onReachArticleEnd,
  ads,
}) => {
  return (
    <>
      {articles.map((article, index) =>
        article ? (
          <Article
            divider={articles.length - 1 !== index ? true : canLoadMore}
            key={article.id}
            {...article}
            url={buildArticleLink(article.id, article.slug)}
            onEndReach={onReachArticleEnd}
            onArticleVisible={onArticleVisible}
            ads={ads}
          />
        ) : null,
      )}
    </>
  );
};
